import { EnvironmentProviders, NgModule } from '@angular/core';
import { AuditTrailModule, provideAuditTrailSettings } from '@iot-platform/audit-trail';
import { AuditTrailService } from './audit-trail.service';
export { TrackingSettingsProviderService } from './tracking-settings-provider.service';
export { AbstractI4bDashboardsService } from './abstract-i4b-dashboards.service';
export { AbstractI4BDataGuardService } from './abstract-i4b-data-guard.service';
export { I4bMasterViewDashboardService } from './i4b-master-view-dashboard.service';

export const provideI4bAuditTrailSettings = (): EnvironmentProviders =>
  provideAuditTrailSettings({
    auditTrailService: AuditTrailService,
    exportLogDetails: false
  });

@NgModule({
  imports: [
    AuditTrailModule.forRoot({
      auditTrailService: AuditTrailService,
      exportLogDetails: false
    })
  ]
})
export class I4bAuditTrailModule {}
